export const VERSION = '4.3.0-bowl';
export const GIT_HASH = '96bd3c6fe687fee44775e4e8688cd8f42cfced97';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'bowl';
